"use client"

import { CustomBenefitItem } from "@/types/NonSyncedTypes"
import { ListItemStoryblok } from "@storyblok-types"
import BenefitItem from "./BenefitItem"

function ListingBenefits({
  title,
  items,
  customItems
}: {
  title?: string
  items?: ListItemStoryblok[]
  customItems?: CustomBenefitItem[]
}) {
  return (
    <div className="items-left mb-10 flex w-[90%] max-w-[40rem] flex-col text-left">
      <h2 className="text-on-surface">{title}</h2>
      <div className="flex flex-col">
        {customItems && customItems.length > 0 ? (
          <>{customItems?.map((item, i) => <BenefitItem header={item.title} details={item.content} key={i} />)}</>
        ) : (
          <>{items?.map(item => <BenefitItem header={item.title} details={item.description} key={item._uid} />)}</>
        )}
      </div>
    </div>
  )
}

export default ListingBenefits
